import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
}

const variantClass: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  danger: 'btn-danger',
  success: 'btn-success',
};

export default function Button({ variant = 'primary', size = 'md', loading, icon, iconPosition = 'left', fullWidth, className = '', children, disabled, style, ...props }: ButtonProps) {
  const sizeStyle: Record<ButtonSize, React.CSSProperties> = {
    sm: { padding: '6px 10px', fontSize: '12px' },
    md: {},
    lg: { padding: '12px 20px', fontSize: '14px' },
  };

  return (
    <button
      type="button"
      className={`btn ${variantClass[variant]} ${className}`}
      disabled={disabled || loading}
      style={{
        ...(size !== 'md' ? sizeStyle[size] : {}),
        ...(fullWidth ? { width: '100%' } : {}),
        ...(disabled || loading ? { opacity: 0.5, cursor: 'not-allowed' } : {}),
        ...style,
      }}
      {...props}
    >
      {loading && <span style={{ display: 'inline-block', width: 'var(--space-4)', height: 'var(--space-4)', border: '2px solid currentColor', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />}
      {!loading && icon && iconPosition === 'left' && icon}
      {children}
      {!loading && icon && iconPosition === 'right' && icon}
    </button>
  );
}
